import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DynamicTable from "../../../../Components/Table/DynamicTable";
import { fetchTaskData } from "../../../../Redux/Slice/ShowAllTask";

const ShowMainTask = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //   const { id } = useParams();

  const { TaskData } = useSelector((state) => state.ShowAllTask);

  useEffect(() => {
    dispatch(fetchTaskData());
  }, [dispatch]);

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return `${date.getDate().toString().padStart(2, "0")}/${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${date.getFullYear()}`;
  };

  const isToday = (isoDate) => {
    const today = new Date();
    const date = new Date(isoDate);
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  const isBetweenDates = (isoDate) => {
    const date = new Date(isoDate);
    const startDate = filters.startDate ? new Date(filters.startDate) : null;
    const endDate = filters.endDate ? new Date(filters.endDate) : null;

    if (startDate && endDate) {
      return date >= startDate && date <= endDate;
    }
    return true; // If no date range selected, return true for all dates
  };

  const [filters, setFilters] = useState({
    status: "",
    Assignby: "",
    assignedTo: "", // New filter for Assigned To
    todayOnly: false,
    startDate: "", // New start date filter
    endDate: "", // New end date filter
  });

  const handleFilterChange = (e) => {
    if (e?.target) {
      // Native event (input/select/checkbox)
      const { name, value, type, checked } = e.target;
      setFilters((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    } else if (e?.name) {
      // Custom object (Autocomplete, etc.)
      setFilters((prev) => ({
        ...prev,
        [e.name]: e.value,
      }));
    }
  };

  // Extract unique options for dropdowns
  const TaskIdOptions = [
    ...new Set(TaskData?.data?.map((el) => el.TaskId?.TastName)),
  ];
  const statusOptions = [...new Set(TaskData?.data?.map((el) => el.Status))];

  const AssingbyOptions = [
    ...new Set(TaskData?.data?.map((el) => el?.AssignedBy?.Name)),
  ];

  const AssigntoOptions = [
    ...new Set(TaskData?.data?.map((el) => el?.MemberId?.Name)),
  ];

  const ComplainColumns = [
    { field: "TaskId", headerName: "Task Name", flex: 1 },
    { field: "Date", headerName: "Date", flex: 1 },
    { field: "DueDate", headerName: "Due Date", flex: 1 },
    { field: "AssignTo", headerName: "Assign To", flex: 1 },
    { field: "AssignBy", headerName: "Assign By", flex: 1 },
    { field: "Status", headerName: "Status", flex: 1 },
  ];

  const filteredRows = TaskData?.data
    ?.map((el, index) => ({
      id: index + 1,
      MainId: el._id,
      TaskId: el?.TaskId?.TastName,
      Date: formatDate(el.AssignDate),
      DueDate: formatDate(el.DueDate),
      AssignTo: el?.MemberId?.Name,
      AssignBy: el?.AssignedBy?.Name,
      Status: el.Status,
      AssignDate: el.AssignDate, // Keep original date for filtering
    }))
    ?.filter((row) => {
      const statusMatch = !filters.status || row.Status === filters.status;
      const assignedByMatch =
        !filters.Assignby || row.AssignBy === filters.Assignby;
      const assignedToMatch =
        !filters.assignedTo || row.AssignTo === filters.assignedTo;
      const todayMatch = !filters.todayOnly || isToday(row.AssignDate);
      const dateRangeMatch = isBetweenDates(row.AssignDate); // Check if date is between selected range

      return (
        statusMatch &&
        assignedByMatch &&
        assignedToMatch &&
        todayMatch &&
        dateRangeMatch
      );
    })
    .reverse();

  const handleRowClick = (row) => {
    navigate(`/showalltask/TaskDetailsDetail/${row.MainId}`); // Navigate to target page with MainId
  };

  return (
    <>
      <div className="subTitle my-5">
        <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
          Show Main Task
        </h3>
      </div>

      <div className="Form_bg_color bg-white shadow-md rounded-md mt-4">
        <div className="grid grid-cols-12 gap-4 p-3 rounded-2xl">
          <div className="col-span-12 flex items-center gap-2">
            <input
              type="checkbox"
              name="todayOnly"
              checked={filters.todayOnly}
              onChange={handleFilterChange}
              className="w-5 h-5"
            />
            <label htmlFor="showToday" className="my-2 font-semibold">
              Show Today Only
            </label>
          </div>

          {/* Task Name Autocomplete */}
          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <h5 className="my-2 font-semibold">Task Name</h5>
            <Autocomplete
              options={TaskIdOptions?.map((name) => ({ label: name }))}
              getOptionLabel={(option) => option?.label}
              value={filters?.taskName ? { label: filters.taskName } : null}
              onChange={(e, newVal) =>
                handleFilterChange({
                  name: "taskName",
                  value: newVal?.label || "",
                })
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="custom-input"
                  placeholder="Enter Task Name"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </div>

          {/* Assign By Autocomplete */}
          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <h5 className="my-2 font-semibold">Assign By</h5>
            <Autocomplete
              className="custom-input"
              options={AssingbyOptions?.map((name) => ({ label: name }))}
              getOptionLabel={(option) => option?.label}
              value={filters.Assignby ? { label: filters.Assignby } : null}
              onChange={(e, newVal) =>
                handleFilterChange({
                  name: "Assignby",
                  value: newVal?.label || "",
                })
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Enter Assigned By"
                  variant="outlined"
                  size="small"
                />
              )}
            />
          </div>

          {/* Assigned To Autocomplete */}
          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <h5 className="my-2 font-semibold">Assigned To</h5>
            <Autocomplete
              className="custom-input"
              options={AssigntoOptions?.map((name) => ({ label: name }))}
              getOptionLabel={(option) => option?.label}
              value={filters.assignedTo ? { label: filters.assignedTo } : null}
              onChange={(e, newVal) =>
                handleFilterChange({
                  name: "assignedTo",
                  value: newVal?.label || "",
                })
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Enter Assigned By"
                  variant="outlined"
                  size="small"
                />
              )}
            />
          </div>

          {/* Status Autocomplete */}
          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <h5 className="my-2 font-semibold">Status</h5>
            <Autocomplete
              className="custom-input"
              options={statusOptions?.map((name) => ({ label: name }))}
              getOptionLabel={(option) => option?.label}
              value={filters.status ? { label: filters.status } : null}
              onChange={(e, newVal) =>
                handleFilterChange({
                  name: "status",
                  value: newVal?.label || "",
                })
              }
              isOptionEqualToValue={(option, value) =>
                option.label === value?.label
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Enter Status"
                  variant="outlined"
                  size="small"
                />
              )}
            />
          </div>

          {/* Start & End Dates */}
          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <h5 className="my-2 font-semibold">Start Date</h5>
            <input
              type="date"
              name="startDate"
              value={filters.startDate}
              onChange={handleFilterChange}
              className="bg-[#F3F8FB] w-full p-2 border-2 rounded border-black"
            />
          </div>

          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <h5 className="my-2 font-semibold">End Date</h5>
            <input
              type="date"
              name="endDate"
              value={filters.endDate}
              onChange={handleFilterChange}
              className="bg-[#F3F8FB] w-full p-2 border-2 rounded border-black"
            />
          </div>
        </div>
      </div>

      <div className="divider my-5">
        <DynamicTable
          rows={filteredRows}
          columns={ComplainColumns}
          onRowClick={handleRowClick}
        />
      </div>
    </>
  );
};

export default ShowMainTask;
